<div class="!bg-modal !text-label !flex !items-center !justify-between">
    <div class="flex-1 text-label" [innerHTML]="title"> </div>
    <button mat-button type="button" class="!ml-[5px] !text-error" color="warn" (click)="clearBar()">Cerrar</button>
    <button *ngIf="undone" mat-button class="!ml-[5px] !text-label" type="submit" color="warn" (click)="undoneActions()">Deshacer</button>
  </div>